module.exports = __webpack_public_path__ + "media/images/gare à promixité-dae96fdd926f915341fc00ecf08304d1.svg";